/**
 * Нийт дүнгийн хөнгөлөлт (2026-10-11) — 2+ гутлын сагсанд кассчин НЭГ дүн
 * бичнэ, энэ функц түүнийг мөрүүдэд үнийн ХАРЬЦААГААР хуваарилна.
 *
 * ЯАГААД МӨРӨНД, `orders.discount_mnt`-д БИШ
 *  Тайлан, урамшуулал `order_lines.line_total_mnt`-ээс уншдаг; нэг гутал
 *  буцаахад тэр мөрийн дүнг буцаана. Захиалгын түвшний хөнгөлөлтийг аль нь
 *  ч мэдэхгүй — орлого хэтэрч, нэг гутлын буцаалт илүү мөнгө өгнө.
 *
 * ДҮРЭМ
 *  · бүхэл төгрөгөөр (баримт аравтын оронгүй); нийлбэр нь ЯГ хөнгөлөлт
 *  · мөр бүрийн хувь ≤ тэр мөрийн дүн (сервер «хөнгөлөлт үнээс их» гэж татгалзана)
 *  · бутархайгаас үлдсэн төгрөгийг хамгийн их бутархайтай мөрүүдэд нэг нэгээр
 */
import { Decimal } from 'decimal.js';
/**
 * `lineTotals` — мөр бүрийн дүн, мөрийн хөнгөлөлт хассаны дараа.
 * Буруу оролт (сөрөг мөр, бутархай/сөрөг хөнгөлөлт, нийтээс их) бол `null`.
 */
export function spreadOrderDiscount(lineTotals, discountMnt) {
    const totals = lineTotals.map((v) => new Decimal(v));
    const discount = new Decimal(discountMnt);
    const sum = totals.reduce((a, t) => a.plus(t), new Decimal(0));
    if (totals.some((t) => t.isNegative()) || discount.isNegative() || !discount.isInteger())
        return null;
    if (discount.greaterThan(sum))
        return null;
    if (discount.isZero())
        return totals.map(() => new Decimal(0));
    const exact = totals.map((t) => discount.times(t).div(sum));
    const shares = exact.map((x) => x.floor());
    let left = discount.minus(shares.reduce((a, s) => a.plus(s), new Decimal(0))).toNumber();
    const byFraction = exact
        .map((x, i) => ({ i, frac: x.minus(x.floor()) }))
        .sort((a, b) => b.frac.comparedTo(a.frac) || a.i - b.i);
    for (const { i } of byFraction) {
        if (left === 0)
            break;
        if (shares[i].plus(1).lessThanOrEqualTo(totals[i])) {
            shares[i] = shares[i].plus(1);
            left -= 1;
        }
    }
    return left === 0 ? shares : null;
}
/**
 * Нэг мөрийн БОДИТООР төлсөн дүн — буцаалт, солилцооны үндэс (2026-10-12).
 *
 * 2026-10-11-ээс өмнөх касс хөнгөлөлтийг захиалгын толгойд (`orders.discount_mnt`)
 * бичдэг байсан; мөрийн дүн түүнийг мэдэхгүй тул бүтэн мөрийн дүнгээр буцаавал
 * худалдан авагч илүү мөнгө авна (1,250,000 − 30,000 төлсөн гутлыг 1,250,000-аар).
 * Захиалгын хөнгөлөлтийг ижил дүрмээр (`spreadOrderDiscount`) мөрүүдэд хувааж,
 * энэ мөрийн хэсгийг хасна. И-баримтын НӨАТ буцаалтад ордоггүй тул энд ч үгүй.
 *
 * `lines` — захиалгын БҮХ мөр (буцаагдсан ч), ТОГТМОЛ дарааллаар: нэг
 * захиалгын мөр бүрийг өөр өөр өдөр буцаасан ч хуваарилалт ижил, нийлбэр нь
 * ЯГ захиалгын хөнгөлөлт.
 */
export function linePaidMnt(lines, orderDiscountMnt, lineId) {
    const index = lines.findIndex((l) => l.id === lineId);
    if (index < 0)
        throw new RangeError(`Мөр захиалгад алга: ${lineId}`);
    const own = new Decimal(lines[index].lineTotalMnt);
    if (new Decimal(orderDiscountMnt).isZero())
        return own;
    // Бүхэл төгрөгөөр боломжгүй бол (бутархай хөнгөлөлт) мөнгөөр — 0.01₮
    const totals = lines.map((l) => l.lineTotalMnt);
    const shares = spreadOrderDiscount(totals, orderDiscountMnt) ??
        spreadOrderDiscount(totals.map((t) => new Decimal(t).times(100)), new Decimal(orderDiscountMnt).times(100))?.map((s) => s.div(100));
    if (!shares)
        throw new RangeError('Захиалгын хөнгөлөлт мөрүүдийн нийлбэрээс их');
    return own.minus(shares[index]);
}
//# sourceMappingURL=discount.js.map